<script setup lang="ts">
import { RouterView } from "vue-router";

import ToastContainer from "@/components/ToastContainer.vue";
</script>

<template>
  <div class="d-flex flex-column justify-content-center min-vh-100 pb-5">
    <RouterView />
    <ToastContainer />
  </div>
</template>

<style lang="scss">
$font-family-sans-serif: "Inter", sans-serif;

@import "bootstrap/scss/bootstrap";
@import "@fontsource/inter/400.css";
@import "@fontsource/inter/500.css";
@import "@fontsource/inter/600.css";

body {
  background: linear-gradient(135deg, #e8f4f8 0%, #d1e7f0 100%);
  color: #1e3a5f;
  font-size: 1.125rem;
  line-height: 1.6;
}

a {
  color: #316693;
}
</style>
